import CustomModal from 'components/Common/CustomModal';
import React, { useState, useEffect } from 'react'
import { inputStyle } from './CreateOrder';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg"
import api from "api";
import { toast } from "react-toastify";


const EditOrder = ({ handleModal, handleVerificationModal, selectedOrder, getOrders }) => {
    console.log("selectedOrder", selectedOrder)
    const pendingBatch = selectedOrder?.batchIds?.find(batch => batch.status === "pending");

    const approvedBatch = selectedOrder?.batchIds?.find(batch => batch.status === "approved");
    const [selectedNames, setSelectedNames] = useState([]);
    const [brand, setBrand] = useState(selectedOrder?.brandId);
    const [loading, setLoading] = useState(false);
    const [allBrands, setAllBrands] = useState([]);
    const [allBatches, setAllBatches] = useState();
    const [open, setOpen] = useState(false);
    const getBrands = () => {
        api("get", "/users?role=brand")
            .then((res) => {
                setAllBrands(res.users);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const handleChangeBrand = (e) => {
        setBrand(e.target.value);
        setSelectedNames([]);
    };

    useEffect(() => {
        getBrands();
    }, []);
    const updateOrder = () => {
        setLoading(true)
        const obj = {
            brandId: brand._id,
            status: selectedNames[0]
            // batchIds: selectedNames.map((item) => item._id),
        };
        api("patch", `/orders/${selectedOrder._id}`, obj)
            .then((res) => {
                setLoading(false)
                handleModal();
                toast.success(res.message);
                getOrders();
            })
            .catch((err) => {
                setLoading(false)
                console.log(err);
            });
    };
    const handleChange = (e) => {
        const value = e.target.value;
        // setSelectedNames((prev) =>
        //     Array.isArray(value) ? value : [...prev, value]
        // );
        setSelectedNames([value]);
        setOpen(false);
    };


    const names = [
        "Pending",
        "Approved",

    ];
    console.log("brand", brand)
    return (
        <CustomModal handleSave={updateOrder} heading='Edit Order' buttonName='Save' handleModal={handleModal} loading={loading}>
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Brand Name</label><br />
            <Select
                value={brand}
                onChange={handleChangeBrand}
                renderValue={() => (brand ? brand.name : "Enter here")}
                sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    '& .MuiSelect-select': inputStyle
                }}
                fullWidth
                IconComponent={(props) => (
                    <Arrow {...props} />
                )}
            >
                {allBrands?.map((item) => {
                    return (
                        <MenuItem key={item._id} value={item}>
                            {item.name}
                        </MenuItem>
                    );
                })}
            </Select>
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Order Status</label><br />
            <Select
                sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                    },
                    '& .MuiSelect-select': inputStyle
                }}
                fullWidth
                displayEmpty
                renderValue={() => selectedNames.length ? selectedNames.join(', ') : "Enter here"}
                // multiple
                IconComponent={(props) => (
                    <Arrow {...props} />
                )}
                open={open}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                value={selectedNames}
                onChange={handleChange}
            >
                {names.map((item) => {
                    return (
                        <MenuItem value={item}>{item}</MenuItem>
                    )
                })}
            </Select>

        </CustomModal>
    )
}

export default EditOrder